import React from 'react'
import SocialIcons from './SocialIcons'

const Footer = () => {
  return (
      <footer>
          <p>Copyrights © 2023 by Adeeb A.Samad - All rights are reserved</p>
          <SocialIcons />
    </footer>
  )
}

export default Footer
